export class TenderStatus {
    static PREPARATION = 'preparation';
    static SUBMITTED = 'submitted';
    static OPEN = 'open';
    static AWARDED = 'awarded';
    static REJECTED = 'rejected';
    static EXECUTION = 'execution';
    static COMPLETED = 'completed';
}

export class AuthRole{
    static STAFF = 'staff';
    static SALES = 'sales';
    static FINANCE = 'finance';
    static ADMIN = 'admin';
}

export const AuthRoleList = [
    { label: 'Staff', value: 'staff' },
    { label: 'Sales', value: 'sales' },
    { label: 'Finance', value: 'finance' },
    { label: 'Admin', value: 'admin' },
]
export const TenderStatusList = [
    { label: 'Preparation', value: 'preparation' },
    { label: 'Submitted', value: 'submitted' },
    { label: 'Open', value: 'open' },
    { label: 'Awarded', value: 'awarded' },
    { label: 'Rejected', value: 'rejected' },
    { label: 'Execution', value: 'execution' },
    { label: 'Completed', value: 'completed' }
]

